import axios from 'axios';
import requestApi from '../../../apirest';
import { apiURL } from '../../../apirest/getAPIURL';

/**
 * Gera um novo link de pagamento na Pagar.me via backend
 * (POST /paymentLinks) a partir de 1 a 3 produtos do carrinho e,
 * opcionalmente, um frete ({ type, fee }).
 */
export async function createPaymentLink(products, name, delivery) {
  const response = await requestApi('/paymentLinks', { products, name, delivery }, 'post');
  return response.data;
}

/**
 * Histórico de links já gerados (mais recentes primeiro).
 */
export async function listPaymentLinks() {
  const response = await requestApi('/paymentLinks', {}, 'get');
  return response.data.doc;
}

/**
 * Ressincroniza o status de um link já gerado com a Pagar.me.
 */
export async function syncPaymentLink(id) {
  const response = await requestApi('/paymentLinks', { id }, 'patch');
  return response.data;
}

/**
 * Remove um link do histórico do admin (soft delete — não cancela o link
 * na Pagar.me).
 */
export async function deletePaymentLink(id) {
  const response = await axios.delete(`${apiURL}/paymentLinks/${id}`, {
    headers: { 'Cache-Control': 'no-cache', 'Content-Type': 'application/json' },
  });
  return response.data;
}
